import { render, staticRenderFns } from "./affiliate-assessment.vue?vue&type=template&id=e165a9e4&scoped=true&"
import script from "./affiliate-assessment.vue?vue&type=script&lang=ts&"
export * from "./affiliate-assessment.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-assessment.vue?vue&type=style&index=0&id=e165a9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e165a9e4",
  null
  
)

export default component.exports